<template>
  <div>
    <div class="select-flight" v-if="inputMode">
      <b-form-group>
        <b-form-select
          v-model="flightTypeSelected"
          :options="flightTypes"
          @input="updateFlightType()"
          :disabled="isDisabled"
        ></b-form-select>
      </b-form-group>
    </div>
    <div v-else>
      <label> {{ flightTypeSelected }}</label>
      <b-button
        class="btn-edit"
        title="Edit FlightType"
        :disabled="isDisabled"
        size="sm"
        variant="light"
        @click="toInputMode"
        ><i class="uil uil-edit font-18 text-secondary"></i
      ></b-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "flightTypeComponent",
  props: {
    flightData: {
      type: Array,
    },
    wcOrders: {
      type: Array,
    },
    flightType: {
      type: String,
    },
    zoneFlightTypes: {
      type: Array,
    },
  },
  data() {
    return {
      flightTypeSelected: null,
      isDisabled: false,
      inputMode: true,
      flightTypes: [
        {
          text: "Flight Type",
          value: null,
        },
      ].concat(this.zoneFlightTypes),
    };
  },
  watch: {
    flightData() {
      if (this.flightData && this.flightData.length > 0) {
        this.flightTypeSelected = this.flightData[0].flight_type;
      }
      if (this.wcOrders.length > 0) {
        if (this.flightData.length > 0) {
          this.isDisabled = false;
        } else {
          this.isDisabled = true;
        }
      } else {
        this.isDisabled = false;
      }
    },
  },
  mounted() {
    this.flightTypeSelected = this.flightType;
    this.isDisabled = false;
  },
  methods: {
    updateFlightType() {
      this.$emit("input", this.flightTypeSelected);
      this.inputMode = false;
    },
    toInputMode() {
      this.inputMode = true;
    },
  },
};
</script>
<style scoped>
.select-flight {
  width: 200px;
}

.btn-edit {
  padding: 0;
  background: none;
  margin-left: 0.5em;
  border: none;
  vertical-align: middle;
}
</style>
